import { SubmitImg } from "../../../../../components/common/Converter";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { createNotification } from "../../../../../createNotification";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";

class LeaveRequestFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }

  // getCurrentUser
  async getCurrentUser() {
    const employeeID = this.view.getCurrentUser().employee.id;
    const employee = await findObjectUseCase().execute("employees", {
      where: { id: employeeID },
    });
    return employee[0];
  }

  onChangeForm(field, value, object) {
    if (field === "startdate" || field === "enddate") {
      const startDate =
        field === "startdate" ? value : this.view.state.startdate;
      const endDate = field === "enddate" ? value : this.view.state.enddate;
      // If isRehab is true, calculate the maximum selectable date for endDate
      if (this.view.state.isRehab && field === "startdate") {
        const adjustedMaxEndDate = new Date(startDate); // Declare variable outside the switch
        const leaveType = object?.leaveType?.name;
        switch (leaveType) {
          case "Rehabilitation Leave":
            adjustedMaxEndDate.setMonth(adjustedMaxEndDate.getMonth() + 6);
            break;
          case "Special Emergency Leave":
            adjustedMaxEndDate.setDate(adjustedMaxEndDate.getDate() + 5);
            break;
          case "Special Leave Privilege":
            adjustedMaxEndDate.setDate(adjustedMaxEndDate.getDate() + 2);
            break;
          case "Maternity Leave":
            adjustedMaxEndDate.setDate(adjustedMaxEndDate.getDate() + 104);
            break;
          case "Special Leave Benefit":
            adjustedMaxEndDate.setMonth(adjustedMaxEndDate.getMonth() + 2);
            break;
          default:
            return;
        }

        this.view.setState({
          startdate: startDate,
          maxEndDate: adjustedMaxEndDate.toISOString().split("T")[0], // Format as "YYYY-MM-DD"
          enddate: adjustedMaxEndDate < new Date(endDate) ? "" : endDate, // Clear endDate if it exceeds max
        });
        return;
      }

      // Validate date range
      // if (new Date(startDate) > new Date(endDate)) {
      //   this.view.showError("End Date should be greater than Start Date");
      //   this.view.setState({ [field]: "" });
      //   return;
      // } else {
      // }
      this.view.setState({ [field]: value });
    } else {
      this.view.setState({ [field]: value });
    }
  }

  getDurationFormula(startdate, enddate) {
    const startDate = new Date(startdate);
    const endDate = new Date(enddate);

    // Calculate the difference in milliseconds
    const differenceInMs = endDate - startDate + 1;

    if (differenceInMs) {
      // Convert milliseconds to days
      const differenceInDays =
        Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1;

      return `${differenceInDays} Day/s`;
    } else {
      return "";
    }
  }

  async hanldeSubmit() {
    // if (Object.keys(this.view.state.selectedFiles).length < 1) {
    //   this.view.showError(`Select at least one attachment`);
    //   return;
    // }

    const currentUser = this.view.getCurrentUser();
    const allAvailableCredit = await findObjectUseCase().execute("leave_cred", {
      where: {
        empID: currentUser.employee.id,
      },
    });

    const invalid = allAvailableCredit.find((item) =>
      ["Forced/Mandatory Leave", "Special Leave Privilege"].includes(
        this.view.state.object.leaveType?.name,
      ),
    );
    if (
      invalid &&
      Object.keys(invalid).length > 0 &&
      Number(invalid?.current) === 0
    ) {
      this.view.showError(
        "Your leave credits have already been exhausted. Please file a vacation leave instead.",
      );
      return;
    }

    const noSupervisorAssigned = this.view.state.employee.every(
      (emp) => !emp.supervisor,
    );
    if (noSupervisorAssigned) {
      this.view.showError("No Supervisor Assigned");
      return;
    }
    const { leaveType, ...restObject } = this.view.state.object;
    const submit = {
      employee: { id: this.view.state.employee[0].id },
      creditDeduction: this.view.state.creditDeduction,
      supervisor: { id: this.view.state.employee[0].supervisor.id },
      startdate: this.view.state.startdate,
      selectedType: this.view.state.object.leaveType.name,
      createdBy: { id: currentUser.id },
      leaveType: { id: leaveType.id },
      ...restObject,
    };

    const endDate =
      submit.halfDay === true ? undefined : this.view.state.enddate;
    const duration = this.getDurationFormula(
      this.view.state.startdate,
      endDate,
    );

    submit.enddate = endDate;

    if (new Date(submit.startdate) > new Date(submit.enddate)) {
      this.view.showError("End Date should be greater than Start Date");
      return;
    }

    submit.duration = duration;
    const ArrayFile = await SubmitImg(this.view.state.selectedFiles);
    submit.selectedFiles = ArrayFile;
    if (this.view.state.objectID !== "") {
      submit.id = this.view.state.objectID;
    }

    await upsertUseCase().execute("leave_request", submit);

    this.view.closeTrainingForm();
    this.view.showSuccess("Success");
    this.view.refetchData();
    //  CREATE NOTIFICATION
    const NOTIFICATION_MESSAGE = "You have a new Leave Request awaiting review";
    const NOTIFICATION_RECEIVER = [this.view.state.employee[0].supervisor.id];
    const NOTIFICATION_REDIRECT = "leaves";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT,
    );

    // this.view.closeTrainingForm();
    // this.view.showSuccess("Success");
    // this.view.refetchData();
  }

  async handleUpdateCompliance(object, status) {
    const ArrayFile = await SubmitImg(this.view.state.selectedFiles);
    try {
      await upsertUseCase().execute("leave_request", {
        id: object.id,
        selectedFiles: ArrayFile,
        stats: status,
      });
      this.view.closeTrainingForm();
      this.view.showSuccess("Leave Request Updated");
      this.view.refetchData();
    } catch (error) {
      this.view.showError(
        "Failed to Update Leave Request: ",
        error.message || error,
      );
    }
  }
}

export default LeaveRequestFormPresenter;
